import React, {useLayoutEffect, useState} from 'react';
import {Router} from 'react-router';
import {ControlledBrowserHistory} from '~/library/navigation';
import {useAppStore} from '~/shared/store/hooks';

const useEarlyEffect = useLayoutEffect;

export function AppRouter({
    children,
    history,
    updateKey: updateKey,
}: React.PropsWithChildren<{
    history: ControlledBrowserHistory;
    updateKey: React.Dispatch<void>;
}>) {
    // redux can be easily replaced by useReducer, if history actions are unused
    // const [] = useReducer(HistoryStack.reduce, undefined, HistoryStack.init);

    const store = useAppStore();
    const getHistoryStack = () => store.getState().history;

    // It's CRITICAL that navigation state is stored in async react state
    // like useState or useReducer and NOT in useSyncExternalStore.
    // Otherwise navigations called in useEffects,
    // including those in <Navigate />, cause infinite render loops
    const [stack, setStack] = useState(getHistoryStack);

    useEarlyEffect(() => {
        const destroy = history.init({
            dispatch: store.dispatch,
        });

        const unsubscribe = store.subscribe(() => {
            const stack = getHistoryStack();
            setStack(stack);
            history.sync(stack);
        });

        return () => {
            destroy();
            unsubscribe();
        };
    }, [store, history]);

    useEarlyEffect(() => {
        window.restartAppAt = (href, state) => {
            // window.location.href = href;
            updateKey();
            history.push(href, state);
        };
    }, [history]);

    const {location, navigationType} = stack;
    return (
        <Router navigator={history} location={location} navigationType={navigationType}>
            {children}
        </Router>
    );
}
